# Order Actions View
# ==================
SupportOrderActionsTemplate = require('../../../order_actions.html.mustache')
Backbone = require 'backbone'
Backbone.$ = $

class SupportOrderActionsView extends Backbone.View
  className: 'order-actions'

  initialize: ->
    @I18nScope = 'modules.support'
    @template = SupportOrderActionsTemplate
    @order = Groupon.Support.currentOrder

  render: ->
    @$el.append toHtml(@template, @toHash(), @I18nScope)

  toHash: ->
    {}

module.exports = SupportOrderActionsView
